<h3>{{editForm.value.isNewRow ? 'Create Peripheral Software' : 'Edit ' + editForm.value.peripheralSoftwareVersion + ' Peripheral Software'}}</h3>
<br />
<form [formGroup]="editForm">
  <div style="display: flex; gap: 10px;">
    <!-- Family Code -->
    <div (click)="onFamilyCodeFormFieldClick()" style="flex: 2">
      <mat-form-field appearance="outline"
        [ngClass]="{'editable-outline': true}"
        style="width: 100%">
        <mat-label>Family Code</mat-label>
        <button mat-icon-button matSuffix tabindex="-1" style="pointer-events: none;">
          <mat-icon class="icon-color-fix-orange">search</mat-icon>
        </button>
        <input type="text"
          matInput
          [ngModelOptions]="{standalone: true}"
          [(ngModel)]="selectedFamilyCodeId"
          [matAutocomplete]="auto"
          (input)="onFamilyCodesFilter($event)"
          placeholder="Search" />
          <mat-autocomplete #auto="matAutocomplete"
            [displayWith]="getFamilyCodeText.bind(this)"
            (optionSelected)="onFamilyCodeSelected($event)">
            @for (fc of filteredFamilyCodes; track fc) {
              <mat-option [value]="fc.familyCodeId">
                {{ getFamilyCodeText(fc.familyCodeId) }}
              </mat-option>
            }
          </mat-autocomplete>
        </mat-form-field>
      </div>
      <!-- Version -->
      <div style="flex: 1">
        <mat-form-field appearance="outline"
          [ngClass]="{'editable-outline': editForm.value.isNewRow}"
          style="width: 100%">
          <mat-label>Version</mat-label>
          @if (!editForm.value.isNewRow) {
            <input matInput [value]="editForm.value.peripheralSoftwareVersion" readonly />
          } @else {
            <input matInput type="text"
              formControlName="peripheralSoftwareVersion"
              maxlength="50"
              matTooltip="Max 50 characters" />
            }
          </mat-form-field>
        </div>
        <!-- Modified by -->
        @if (!editForm.value.isNewRow) {
          <div style="flex: 2">
            <mat-form-field appearance="outline" style="width: 100%">
              <mat-label>Modified by</mat-label>
              <input matInput [value]="editForm.value.modifUser" readonly />
            </mat-form-field>
          </div>
        }
      </div>
      <div style="display: flex; gap: 10px;">
        <!-- Software File -->
        <div (click)="fileInput.click()" style="flex: 0.5">
          <mat-form-field appearance="outline"
            [ngClass]="{'editable-outline': true}"
            style="width: 100%">
            <mat-label>Software File</mat-label>
            <input matInput
              [value]="editForm.value.softwareFileName"
              readonly
              [placeholder]="!editForm.value.softwareFileName ? 'No file selected' : ''" />
              <button mat-icon-button
                matSuffix
                aria-label="Browse file">
                <mat-icon matSuffix class="icon-color-fix-orange">sync</mat-icon>
              </button>
            </mat-form-field>
            <input #fileInput
              type="file"
              style="display: none"
              (change)="onFileChange($event)" />
            </div>
          </div>
          @if (!editForm.value.isNewRow) {
            <h3>Release notes</h3>
            <div style="display: flex; gap: 20px; flex-wrap: wrap;">
              <!-- Existing release notes -->
              @for (note of editForm.value.availableReleaseNotes || []; track note) {
                <div (click)="openReleaseNotes(note)" style="flex: 0 0 150px; max-width: 150px; cursor: pointer;">
                  <mat-form-field appearance="outline"
                    [ngClass]="{'editable-outline': true}"
                    style="width: 100%">
                    <mat-label>Release notes</mat-label>
                    <input matInput [value]="getReleaseNoteLabelText(note.language)" readonly />
                    <button mat-icon-button matSuffix aria-label="Open">
                      <mat-icon matSuffix class="icon-color-fix-orange">open_in_new</mat-icon>
                    </button>
                  </mat-form-field>
                </div>
              }
              <!-- New release button -->
              <div style="flex: 0 0 150px; max-width: 150px; cursor: pointer;" (click)="openReleaseNotes(null, true)">
                <mat-form-field appearance="outline"
                  [ngClass]="{'editable-outline': true}"
                  style="width: 100%">
                  <mat-icon matPrefix class="icon-color-fix-orange">add</mat-icon>
                  <input matInput [value]="'New release'" readonly />
                </mat-form-field>
              </div>
            </div>
          }
          <mat-dialog-actions align="end">
            <button class="btn button-fix button-color-fix-red" mat-button (click)="onCancel()" cdkFocusInitial>Cancel</button>
            <button class="btn button-fix button-color-fix-orange"
              mat-button
              [disabled]="!anyChange()"
              (click)="onSave()"
              [matTooltip]="anyChange() ? (editForm.value.isNewRow ? 'Create new release' : 'Save changes') : 'Please set values'">
              {{editForm.value.isNewRow ? 'Create' : 'Save'}}
              <mat-icon style="color:white !important" class="icon-color-fix">{{editForm.value.isNewRow ? 'add_box' : 'save'}}</mat-icon>
            </button>
          </mat-dialog-actions>
        </form>